export default "__VITE_ASSET__B3O_dv8K__"